import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Button } from '../button/button'
import { LinkButton } from '../button/link-button'
import Modal from '../modal/modal'
import Text from '~/components/text/text'

interface EventQaaModalProps {
	toggleModal: () => void
	bookingUrl?: string
	country?: string
}

export default function EventQaaModal({
	toggleModal,
	bookingUrl,
	country,
}: EventQaaModalProps) {
	const { t } = useTranslation()
	return (
		<Modal onClose={toggleModal} title={t('terms_and_conditions_q_and_a')}>
			<>
				<div className="flex flex-col">
					<div className="py-4">
						<Text>{t('events_information_modal_description')}</Text>
					</div>
					{country === 'Sverige' && (
						<div className="my-2 flex flex-col gap-y-4">
							<div>
								<Text className="font-bold">
									{t('events_handbag_restriction_info')}
								</Text>
								<Text>{t('events_handbag_restriction_description')}</Text>
								<Link
									className="text-bold underline"
									target="_blank"
									to="https://polisen.se/lagar-och-regler/vaskforbud-pa-storre-evenemang/"
								>
									{t('events_read_on_police_website')}
								</Link>
							</div>
						</div>
					)}
				</div>
				<div className="mt-4 flex flex-row justify-between gap-x-4">
					{bookingUrl && (
						<LinkButton
							target="_blank"
							external
							variant="secondary"
							to={bookingUrl}
						>
							{t('event_read_on_event_website')}
						</LinkButton>
					)}
					<Button onClick={toggleModal} variant="primary">
						{t('action_close')}
					</Button>
				</div>
			</>
		</Modal>
	)
}
